import { Component } from '@angular/core';
import { Router, RouterOutlet, type Event, NavigationEnd } from '@angular/router';
import { SpinnerComponent } from './spinner/spinner';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { IStaticMethods } from 'preline/preline';
import { BackToTopComponent } from './components/back-to-top.component';
import { ToastModule } from 'primeng/toast';
import { NgZone } from '@angular/core';
import { take } from 'rxjs';
import { AppUpdateDialogComponent } from './update/app-update-dialog.component';

registerLocaleData(localeEs);
declare global {
  interface Window {
    HSStaticMethods: IStaticMethods
  }
}

@Component({
  selector: 'app-root',
  standalone: true, // standalone is needed if the component is not in a module
  imports: [RouterOutlet, SpinnerComponent, BackToTopComponent, ToastModule, AppUpdateDialogComponent], // Add SpinnerComponent to imports
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  title = 'MMM España';

  constructor(private router: Router, private ngZone: NgZone) { }

  ngOnInit() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.ngZone.onStable.pipe(take(1)).subscribe(() => {
          setTimeout(() => {
            try {
              window.HSStaticMethods?.autoInit();
            } catch (error) {
              // Ignorar errores de Preline si el DOM no está listo o hay conflictos menores
              // console.warn('Preline autoInit warning:', error); 
            }
          }, 100);
        });
      }
    });
  }
}
